<template>
	<div id="left">
		<div class="left">
			<div class="left1">
				<div class="left1_1" @mouseenter="selectedIndex = i" @mouseleave="selectedIndex = localLeftIndex"
					:class="localLeftIndex === i || selectedIndex === i ? 'left1_2' : ''" v-for="(item, i) in leftTitle"
					:key="i" @click="leftSelect(i)">
					<img class="icon-hover" :src="localLeftIndex === i || selectedIndex === i ? item.icon : item.uIcon"
						alt="">
					{{ item.title }}
				</div>
				<div class="leftMenuBgColor"></div>
			</div>
			<div class="left2" @click="openVip">
				<img src="@/assets/image/home/vip_cz.png" />
			</div>
		</div>
		<vipPopup></vipPopup>
	</div>
</template>

<script>
import data from '@/assets/data';
import vipPopup from './vip_popup.vue' //vip页面
import { EventBus } from '@/utils/eventBus';
import api from '@/api/api';
export default {
	components: {
		vipPopup
	},
	props: {
		leftIndex: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			leftTitle: data.leftTitle, // 左侧title
			localLeftIndex: this.leftIndex, // 本地数据属性，初始值为 prop 的值
			selectedIndex: -1 //鼠标悬停的索引
		};
	},
	watch: {
		leftIndex(newValue) {
			this.localLeftIndex = newValue; // 监听 prop 的变化，更新本地数据属性
		}
	},
	methods: {
		leftSelect(i) {
			if (this.localLeftIndex == i) return
			this.localLeftIndex = i;
			this.selectedIndex = i
			this.routerPathJump(i)
		},
		openVip() {
			api.getUserinfo().then((res) => {
				if (res.code == 200) {
					EventBus.$emit('openVip')
				} else {
					EventBus.$emit('openLogin')
				}
			})
		}
	}
};
</script>

<style scoped lang="scss">
#left {
	width: 249px;
	height: 100%;
	padding-top: 16px;
	flex-shrink: 0;
}

.left {
	height: 100%;
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: space-between;
	border-radius: 0 20px 0 0;
	// background: #EAFAFF;
	padding: 30px 0 20px;
	background: url('@/assets/image/home/leftBg.png') no-repeat;
}

.left1 {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	position: relative;
}

.left1_1 {
	width: 226px;
	height: 45px;
	z-index: 1;
	margin-bottom: 5px;
	display: flex;
	align-items: center;
	border-radius: 4px;
	padding: 0 20px;
	font-size: 18px;
	color: #000000;
	cursor: pointer;
	position: relative;
	font-family: Microsoft YaHei;
	// transition: width 0.3s ease;

	&:hover {
		background: #1492FF;
		color: #FFFFFF;
		border-radius: 26px 0px 0px 26px;
	}
}


.left1_2 {
	background: #1492FF;
	color: #FFFFFF;
	border-radius: 26px 0px 0px 26px;
	font-weight: bold;
}

.left1_1 img {
	width: 23px;
	height: 23px;
	margin-right: 8px;
}

.left2 {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	img {
		width: 225px !important;
		height: 314px !important;
	}
}
</style>